// extracted by mini-css-extract-plugin
module.exports = {"list":"AppSwitcherIconList_list__qTIkE","item":"AppSwitcherIconList_item__Gwq3Y"};